// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container-OzqPd {
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid var(--border-color);
  padding: 0px 20px;
}

.header-logo-wrGgW {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}

.header-title-on7Oz {
  font-size: 16px;
  font-weight: 500;
}

.header-balanceContainer-welFp {
  margin-left: auto;
  margin-right: 32px;
  font-size: 14px;
  font-weight: 500;
}

.header-balance-eQyFb {
  color: var(--money-color);
}

.header-user-lBR6x {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header-name-KExn1 {
  font-size: 14px;
  font-weight: 500;
  margin-right: 12px;
}

.header-icon-wtski {
  --size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/header.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container {\n  height: 44px;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  background-color: white;\n  border-bottom: 1px solid var(--border-color);\n  padding: 0px 20px;\n}\n\n.logo {\n  width: 24px;\n  height: 24px;\n  margin-right: 20px;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.balanceContainer {\n  margin-left: auto;\n  margin-right: 32px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.balance {\n  color: var(--money-color);\n}\n\n.user {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.name {\n  font-size: 14px;\n  font-weight: 500;\n  margin-right: 12px;\n}\n\n.icon {\n  --size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `header-container-OzqPd`,
	"logo": `header-logo-wrGgW`,
	"title": `header-title-on7Oz`,
	"balanceContainer": `header-balanceContainer-welFp`,
	"balance": `header-balance-eQyFb`,
	"user": `header-user-lBR6x`,
	"name": `header-name-KExn1`,
	"icon": `header-icon-wtski`
};
export default ___CSS_LOADER_EXPORT___;
